import { Link as RouterLink } from "react-router-dom";
import type { LinkComponentProps } from "@marekl/adminer";

export function LinkComponent({ to, children, className, ...rest }: LinkComponentProps) {
  return (
    <RouterLink to={to} className={className} {...rest}>
      {children}
    </RouterLink>
  );
}
